import { MAX_COMPARISON_ITEMS, MIN_COMPARISON_ITEMS } from './useProductComparisonStore';

/**
 * TODO(IMC-3339): Move to Umbraco dictionary items and read through `useTranslation`.
 * `translate()` only accepts keys from the generated `TranslationKey` union, so the copy is
 * kept here until the ticket adding these keys ships. Suggested keys are listed alongside
 * each string so the swap is mechanical.
 */
export const comparisonCopy = {
    /** plp.compare.add */
    add: 'Sammenlign',
    /** plp.compare.select */
    select: 'Vælg',
    /** plp.compare.maxReached */
    maxReached: `Du kan sammenligne op til ${MAX_COMPARISON_ITEMS} varer`,
    /** plp.compare.maxSelected */
    maxSelected: 'Max antal valgt',
    /** plp.compare.trayTitle */
    trayTitle: 'Sammenlign varer',
    /** plp.compare.intro */
    intro: `Vælg op til ${MAX_COMPARISON_ITEMS} varer og få dem stillet op side om side`,
    /** plp.compare.selectMore */
    selectMore: `Vælg mindst ${MIN_COMPARISON_ITEMS} varer for at sammenligne`,
    /** plp.compare.submit */
    submit: 'Sammenlign',
    /** plp.compare.clear */
    clear: 'Ryd',
    /** plp.compare.remove */
    remove: (name: string) => `Fjern ${name} fra sammenligning`,
    /** plp.compare.expand */
    expand: 'Vis sammenligning',
    /** plp.compare.collapse */
    collapse: 'Skjul sammenligning',
    /** plp.compare.emptySlot */
    emptySlot: (remaining: number) => `Vælg op til ${remaining} mere`,
    /** plp.compare.selected */
    selected: 'valgt',
    /** plp.compare.seeSelection */
    seeSelection: 'Se valg',
    /** plp.compare.progress */
    progress: (selected: number) => `${selected} af ${MAX_COMPARISON_ITEMS} valgt`,
    /** plp.compare.announceAdded - screen reader only, followed by `progress` */
    announceAdded: 'Tilføjet til sammenligning.',
    /** plp.compare.announceRemoved - screen reader only, followed by `progress` */
    announceRemoved: 'Fjernet fra sammenligning.',
    /** plp.compare.announceCleared - screen reader only */
    announceCleared: 'Sammenligning ryddet.',
} as const;
